export const texts = {
    contactBanner: "Pour nous contacter :",
    contactBannerAriaLabel: "Bannière de contact",
    contactBannerLink: "Cliquer ici",
    contactBannerLinkAriaLabel: "Accéder à la page de contact (nouvelle fenêtre)",
}
